import store from '../store'
import moment from 'moment'
import { merge } from 'lodash'
import UVHelper from '../helpers/PGSHelper.js';
export default class TableRestaurant {
    monedaDefault = "";
    constructor() {

    }

    static getTableById(departamento,id,contenedoresData){
        let PGSHelper = new UVHelper();
        let contenedores = {};
        /*await store.getters.getFirebaseApp.database
        .ref("AYB/Contenedores/"+departamento+"/"+id)
        .once("value", (snapshot) => {
            contenedores = snapshot.val();
        });*/
        let contenedor = PGSHelper.getById(contenedoresData,'id',id);
        return contenedor;
    }

    static async getAccountsByTable(id){
        /*let cuentasAYB      = store.getters["dataLists/getAybCuentas"];
        let cuentasByTable  = [];
        cuentasAYB.forEach((cuenta)=>{
          
          if(cuenta.Contenedor.Id == id){
            cuentasByTable.push(cuenta);
          }
        });
        
        return cuentasByTable;*/
        let cuentas    = [];
        let data       = store.getters.getFirebaseApp.firestore.collection("AYB_Cuentas").where('Contenedor.Id','==',id).where("Tenant", "==", store.getters.getFirebaseApp.tenant).where("Estatus" ,'==',1)
        data           = await data.get();
        cuentas        = data.docs.map(doc=>{return {id:doc.ref.id,Selected:false,...doc.data()}});
        let cuentasActivas = [];
        cuentas.forEach((cuenta)=>{
          if(cuentas.Estatus != 0){
            cuentasActivas.push(cuentasActivas);
          }
        })
        return cuentas;
    }

    static getAllTables(contenedoresData){
      let PGSHelper = new UVHelper();
      let contenedores = contenedores;
      let data = PGSHelper.cloneObj(contenedoresData);
      let array = data.sort(function (a, b) {
        if (b.Nombre > a.Nombre) return -1;
        if (b.Nombre < a.Nombre) return 1;
      });
      return array;
    }

    static async getTableByDepartment(id){
        let contenedores
        await store.getters.getFirebaseApp.database
        .ref("AYB/Contenedores")
        .once("value", (snapshot) => {
            if (snapshot.exists()) {
              contenedores = [];
              Object.keys(snapshot.val()).forEach((id) => {
                const toAdd = snapshot.val()[id];
                if (toAdd) {
                  toAdd.Id = id;
                  contenedores.push(toAdd);
                }
              });
            }
        });

        return contenedores;
    }
}